import React from 'react';
import GridViewRoundedIcon from '@mui/icons-material/GridViewRounded';
import HowToRegRoundedIcon from '@mui/icons-material/HowToRegRounded';
import AssessmentRoundedIcon from '@mui/icons-material/AssessmentRounded';
import FingerprintRoundedIcon from '@mui/icons-material/FingerprintRounded';
import PendingActionsRoundedIcon from '@mui/icons-material/PendingActionsRounded';
import SensorsRoundedIcon from '@mui/icons-material/SensorsRounded';
import TimelapseRoundedIcon from '@mui/icons-material/TimelapseRounded';
import TabbedPage from '../components/TabbedPage';
import StaffAttendanceOverviewPage from '../components/LeaveAttendanceComps/StaffAttendanceOverviewPage';
import AddStaffAttendancePage from '../components/LeaveAttendanceComps/AddStaffAttendancePage';
import AttendanceReportsPage from '../components/LeaveAttendanceComps/AttendanceReportsPage';
import BiometricStaffMappingPage from '../components/LeaveAttendanceComps/BiometricStaffMappingPage';
import PunchRequestsTab from '../components/LeaveAttendanceComps/PunchRequestsTab';
import BiometricLogsTab from '../components/LeaveAttendanceComps/BiometricLogsTab';
import TimesheetTab from '../components/LeaveAttendanceComps/TimesheetTab';

const TABS = [
    { key: 'overview', label: 'Overview', icon: GridViewRoundedIcon, module: 'attendance-overview', render: () => <StaffAttendanceOverviewPage /> },
    { key: 'attendance', label: 'Attendance', icon: HowToRegRoundedIcon, module: 'attendance', render: () => <AddStaffAttendancePage /> },
    { key: 'reports', label: 'Reports', icon: AssessmentRoundedIcon, module: 'attendance-reports', render: () => <AttendanceReportsPage /> },
    { key: 'punch-requests', label: 'Punch Requests', icon: PendingActionsRoundedIcon, module: 'attendance', render: () => <PunchRequestsTab /> },
    { key: 'biometric-mapping', label: 'Biometric Mapping', icon: FingerprintRoundedIcon, module: 'attendance', render: () => <BiometricStaffMappingPage isEmbedded /> },
    { key: 'timesheet', label: 'Attendance History', icon: TimelapseRoundedIcon, module: 'attendance', render: () => <TimesheetTab /> },
    { key: 'biometric-logs', label: 'Biometric Logs', icon: SensorsRoundedIcon, module: 'attendance', pageBtn: true, render: () => <BiometricLogsTab /> },
];

export default function AttendanceLeavePage() {
    return <TabbedPage tabs={TABS} />;
}
